<template>
    <div class="filling-goods-div">
      <div style="padding-top: 5px; font-size: 16px; margin:8px ">货位上架</div>
      <span style="color: red" v-if="hostcs">测试服</span>
      <div style="display: flex; justify-content: space-between; align-items: center">
        <van-button
          type="info"
          size="small"
          style="display: flex"
          :text="ray"
          @click="holdRay()"
        ></van-button>
        <div style="display: flex; flex-wrap: wrap; width: 5rem;font-size: 20px;">
          <input
            id="reel-input"
            style="margin-bottom: 10px;height: 25px; width: 4.5rem;"
            @keyup.enter="goGck()"
            ref="getIDInpot"
            v-model="goods"
            v-on:blur="hideMessage('goods')"
            readonly
            autocomplete="off"
            placeholder="扫描货位"
          />
          <input
            id="gck_number-input"
            style="height: 25px; width: 4.5rem;"
            @keyup.enter="add_reel(reeldata)"
            ref="getGCKInpot"
            v-model="reeldata"
            v-on:blur="hideMessage('reeldata')"
            readonly
            autocomplete="off"
            placeholder="扫描卷号条码"
          />
        </div>
      </div>
      <div :style="style">
        <div class="goods-info-two" v-for="(i, index) in data" :key="index">
          <div class="info-order-put">
            <div style="font-size: 0.5rem;">卷号：</div>
            <span style="font-size: 0.5rem; margin-right: 20px">{{ i['reeldata'] }}</span>
            <!-- <span>
              <div v-if="outNumber === '未出库'">
                <input v-model="i['all_num']" v-on:blur="countAll()" />
                米
              </div>
              <div v-else>{{ i["all_num"] }}米</div>
            </span> -->
          </div>
          <div>
            <van-icon
              name="cross"
              @click="deleteData(index, i['reeldata'])"
              style="margin: 5px 0"
            />
          </div>
        </div>
      </div>
      <div class="filling-goods-bottom" style="display: flex">
        <van-button type="warning" class="bottom-button" @click="go_index()"
          >回首页</van-button
        >
        <van-button
          type="info"
          class="bottom-button"
          @click="PutGoods()"
          >上架货位</van-button>
          <div style="margin: 0 10px; font-size: 18px;">已扫卷数：{{ reel_count }}</div>
      </div>
    </div>
  </template>
  
  <script>
  import $ from "jquery";
  import { mapState, mapMutations } from "vuex";
  import { Dialog } from "vant";
  import { Toast } from "vant";
  import Barcode from '@/components/Barcode';
  export default {
    name: "GoodsPut",
    components: {
      Barcode
    },
    data() {
      return {
        hostcs: false,
        more_show: false,
        ray: "扫描中",
        id: "",
        supplier_xh: "",
        count: "",
        data: [],
        style: "",
        reeldata: "",
        goods:"",
        out_num: "",
        infoType: "1111",
        reeldata_haveAll: {},
        gck_number_data: "",
        PutGoodsType: true,
        outNumber: "未出库",
        username: "",
        // type: "orderInfo",
        count: "",
        show_print: false,
        Dydata:{},
        reel_count: 0,
      };
    },
    mounted() {
      // let reel = this.$route.query.reel
      // this.reeldata = reel
      // if (typeof this.reeldata !== 'undefined') {
      //   if(this.reeldata.length > 0){
      //      this.goGck()
      //   }
      // }
      this.username = JSON.parse(window.localStorage.getItem("userinfo"));
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.style =
        "text-align: left;width: 100%;height: " + h * 0.56 + "px;overflow:scroll";
      setTimeout(() => {
        if (this.outNumber === "未出库") {
          this.focus();
        }
      }, 500);
      if (window.location.host.indexOf("cspda") !== -1) {
        this.hostcs = true;
      }
    },
    methods: {
      goGck() {
        // 输入卷号 弹出现存量
        this.get("/business/getGoods", { goods_num: this.goods }).then(
          (res) => {
            if(res.data.status){
              this.gck_input();
            }else{
              this.goods="";
              Toast(res.data.msg);
            }
          }
        );
      },

      hideMessage(title) {
        if (title === "goods") {
          if (this.goods === "") {
            this.ray = "已暂停，点击我继续扫码";
          }
        }
        if (title === "reeldata") {
          if (this.reeldata === "") {
            this.ray = "已暂停，点击我继续扫码";
          }
        }
      },
      holdRay() {
        this.ray = "扫描中";
        if (this.goods === "") {
          this.focus();
        } else if (this.reeldata === "") {
          this.gck_input();
        }
      },
      focus() {
        this.$refs.getIDInpot.focus();
        this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        setTimeout(() => {
          this.$refs.getIDInpot.removeAttribute("readonly");
        }, 200);
      },
      gck_input() {
        this.$refs.getGCKInpot.focus();
        this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
        setTimeout(() => {
          this.$refs.getGCKInpot.removeAttribute("readonly");
        }, 200);
      },
      async add_reel(reeldata) {
        console.log(reeldata)
        // if(gck_number_title.indexOf('-') !== -1){
        //   // 说明有 -
        //   let index = gck_number_title.indexOf('-')
        //   gck_number_title = gck_number_title.substring(0 , index)
        // }
        if (this.reeldata_haveAll[reeldata] !== undefined) {
          Toast("卷号不能重复");
          this.reeldata = "";
          return;
        }
        this.reeldata_haveAll[reeldata] = "";
        this.get("/business/getNormsware", { reel: reeldata }).then(
          (res) => {
            if(res.data !=""){
              let newData = {};
              newData["reeldata"] = reeldata;
              this.data.push(newData);
              this.reel_count = this.data.length;
            }else{
              delete this.reeldata_haveAll[reeldata];
              Toast('该卷号不存在！');
            }
          }
        );
        this.gck_input();
        this.reeldata = "";
      },
      deleteData(index, reeldata) {
        console.log(index, reeldata);
        Dialog.confirm({
          message: "确定要删除该卷号吗？",
        }).then(() => {
          let mxm = this.data[index].reeldata;
          this.data.splice(index, 1);
          delete this.reeldata_haveAll[mxm];
          this.reel_count = this.data.length;
        });
      },
      go_index() {
        Dialog.confirm({
          message: "确定要回首页吗？",
        })
          .then(() => {
            this.$router.push("/home");
          })
          .catch(() => {
            // on cancel
          });
      },

      async PutGoods() {
        if (this.data.length === 0) {
          return;
        }
        if (!this.PutGoodsType) {
          Toast("不要连续上架");
          return;
        }
        this.PutGoodsType = false;
        let put_info;
        let data={
          goods_num: this.goods,
          reel:"",
        };
        for (let i of this.data) {
          data.reel += i.reeldata + ",";
        }
          put_info = await this.get("/business/doGoods", data);
        
        if (put_info.data.status === 1) {
          this.data=[];
          this.goods="";
          this.reeldata_haveAll={};
          this.reel_count = 0;
          Toast(put_info.data.msg);
        }else{
          Toast(put_info.data.msg)
        }
        // this.id = out_info.data.data.out_detail[0].oid;
        this.PutGoodsType = true;
        // this.outNumber = out_info.data.data.out.status;
        // this.infoType = "";
        // this.out_num = out_info.data.data.out.out_num;
      },

    },
  };
  </script>
  
  <style lang="less">
  @import "../style/outOrderInfo.less";
  .goods-info-two {
    margin-top: 10px;
    background-color: #f2f2f2;
    padding: 10px 10px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .info-order-put {
    width: 100%;
    display: flex;
    //padding-top: 5px;
    justify-content: flex-start;
    align-items: flex-end;
  }
  .list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
  }
  
  .list-data-div-a {
    padding-right: 3px;
    text-align: left;
    font-size: 14px;
  }
  input::placeholder {
  font-size: 16px; /* placeholder 字体大小 */
  color: #999; /* placeholder 颜色 */
  }
  </style>